import React from "react";

import { MemberProfileActivityEntry } from "../../../component-library";

export const ReportGeneratedActivity = (props) => {
  const { keyContent, localCreatedTime } = props;
  const { report_type } = keyContent;

  return (
    <MemberProfileActivityEntry
      headerClassName="apti-MemberProfileActivityEntry__Header__Secondary"
      iconAlt="ReportGeneratedIcon"
      iconSrc="icons/report-icon-secondary.svg"
      localDateTime={localCreatedTime}
      subTitle={`${report_type} is In Progress`}
      title="Report Generated"
    />
  );
};

export const ReportCompletedActivity = (props) => {
  const { keyContent, localCreatedTime } = props;
  const { completed_by, report_type } = keyContent;

  return (
    <MemberProfileActivityEntry
      headerClassName="apti-MemberProfileActivityEntry__Header__Primary"
      iconAlt="ReportCompletedIcon"
      iconSrc="icons/report-icon-primary.svg"
      localDateTime={localCreatedTime}
      subTitle={`${report_type} is Completed`}
      title="Report Completed"
    >
      <div className="fs-14">{completed_by && `Completed by ${completed_by}`}</div>
    </MemberProfileActivityEntry>
  );
};
